import hexWithOpacity from "core-web/utils/hexWithOpacity";
import styled from "theme/libs/styled";
import Box from "theme/components/boxes/Box";

const PinkBox = styled(Box)`
    background-color: ${({ theme }) => `${hexWithOpacity(theme.colors.lightPink, 50)}`};
    color: ${({ theme }) => `${theme.colors.red}`};
`;

PinkBox.propTypes = Box.propTypes;
PinkBox.defaultProps = Box.defaultProps;

export default PinkBox;
